var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.addClass + ' nh-btn' + (_vm.version ? ` version-${_vm.version}` : ''),style:(`--icon: url(${_vm.icon})`),on:{"click":function($event){_vm.link ? null : _vm.$emit('click')}}},[(_vm.loader)?_c('b-spinner',{attrs:{"small":"","label":"small spinner"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }